export default function AdSensePlaceholder({ position = "banner", className = "" }) {
  if (process.env.REACT_APP_SHOW_ADS_PLACEHOLDERS !== "true") return null;

  const heights = {
    banner: "min-h-[90px] sm:min-h-[100px]",
    rectangle: "min-h-[250px]",
    sidebar: "min-h-[250px]",
  };

  return (
    <div
      data-testid="adsense-placeholder"
      className={`w-full ${heights[position]} bg-slate-50 border-2 border-dashed border-slate-300 rounded-xl flex flex-col items-center justify-center text-slate-400 text-xs font-medium my-6 space-y-1 ${className}`}
      aria-label="Espace publicitaire"
    >
      <span className="text-slate-300 text-lg font-heading">AD</span>
      <span>Espace Publicitaire</span>
      {position === "banner" && <span className="text-slate-300 text-xs">728×90</span>}
      {position === "rectangle" && <span className="text-slate-300 text-xs">300×250</span>}
      {position === "sidebar" && <span className="text-slate-300 text-xs">300×250</span>}
    </div>
  );
}
